module.exports = __webpack_public_path__ + "static/media/vacaturepagina-nog-student.b55645ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Vacatures/Overzicht/vacaturepagina-nog-student.jpg
// module id = 755
// module chunks = 0